import React, { useState } from "react";
import { useContext } from "react";
import { Award } from "src/domain/award";
import { Option } from "src/domain/roulette";
import { User } from "src/domain/user";

const StorageContext = React.createContext<any>({});
export const useStore = () => useContext(StorageContext);

export const Provider: React.FC = ({ children }) => {
  const [awards, setAwards] = useState<Award[]>([]);
  const [spin, setSpin] = useState<boolean>(false);
  const [award, setAward] = useState<Option>();
  const [winner, setWinner] = useState<number>();
  const [code, setCode] = useState<number>(0);
  const [rouletteEvent, setRouletteEvent] = useState();
  const [user, setUser] = useState<User>({
    email: "",
    type: "",
  });

  const value = {
    award,
    user,
    code,
    rouletteEvent,
    setRouletteEvent,
    updateCode: setCode,
    updateUser: setUser,
    winner,
    updateWinner: setWinner,
    updateAward: setAward,
    toSpin: () => setSpin(true),
    setSpin,
    isSpinning: spin,
    awards: awards,
    updateAwards: setAwards,
  };

  return (
    <StorageContext.Provider value={value}>{children}</StorageContext.Provider>
  );
};
